import { useFormContext } from "react-hook-form";
import { Flex } from "src/components/Flex.tsx";
import React from "react";
import type { SystemSettingsFormValues } from "src/admin/administration/tabs/SystemTab/types.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { CheckboxField } from "src/components/Form/fields/CheckboxField.tsx";

export const ProductSettings = () => {
  const { t } = useTranslation(TranslationNamespaceEnum.Administration);
  const form = useFormContext<SystemSettingsFormValues>();
  return (
    <Flex flexDirection={"column"} gap={"15px"}>
      <CheckboxField
        label={t("system.form.fields.prices_defined_in_net.label")}
        control={form.control}
        name={"prices_defined_in_net"}
      />
      <CheckboxField
        label={t("system.form.fields.prices_show_in_net.label")}
        control={form.control}
        name={"prices_show_in_net"}
      />
    </Flex>
  );
};
